import '@/common/scss/_global.scss';

import {App, createApp, nextTick} from 'vue';
import {RegisterExternalComponentsPlugin} from '@malt/joy-entrypoint/src/vue/plugins';
import I18nPlugin from '@malt/vue3-i18n';
import {pinia} from '@/logged/common/pinia';
import {loadApiContext} from '@/logged/config';
import AppLogged from '@/logged/App.vue';
import AppUnlogged from '@/unlogged/App.vue';
import {JoyVuePlugin} from '@maltjoy/core-vue';
import '@maltjoy/core-vue/dist/style.css';

function getApp(isConnected = false) {
    let app: App<Element>;

    if (isConnected || window.isConnected) {
        // Don't await on purpose, display app with a loading state
        loadApiContext(pinia);
        app = createApp(AppLogged);
        app.use(pinia);
    } else {
        app = createApp(AppUnlogged);
        app.use(pinia);
    }

    app.use(I18nPlugin);
    app.use(JoyVuePlugin);
    app.use(RegisterExternalComponentsPlugin, {
        registerExternalComponents: ['calendar'],
    });
    return app;
}

(async () => {
    try {
        const app = getApp();
        app.mount('#navbar');

        if (!window.isConnected) {
            window.addEventListener(
                'user:connected',
                async () => {
                    app.unmount();
                    await nextTick();

                    const newApp = getApp(true);
                    newApp.mount('#navbar');
                },
                {once: true},
            );
        }
    } catch (err) {}
})();
